var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 4,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M7 2.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM11.666 2.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM2.333 2.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 2.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM11.666 2.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM2.333 2.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z"
  })));
};
export default SvgDotsHorizontal;